import React from "react";
import OfferTokenizedContent from "components/OfferTokenizedContent/OfferTokenizedContent";
import { ComponentBackgroundColor } from "types/componentBackground";
import { LocationSpecificOffer } from "../useLocationSpecificOffers/types";
import LinkCard from "components/Card/LinkCard";

export interface OfferSliderCardProps {
  offer: LocationSpecificOffer;
  cardBackgroundColor?: ComponentBackgroundColor;
}

const OfferSliderCard: React.FC<OfferSliderCardProps> = ({
  offer,
  cardBackgroundColor
}) => {
  const title = offer.cardContent?.title;
  const altText = typeof title == "string" ? title : undefined;

  return (
    <LinkCard
      backgroundColor={cardBackgroundColor}
      image={offer.cardContent?.image}
      imageAltText={altText}
      title={
        <OfferTokenizedContent
          content={offer.cardContent?.title}
          tokenValues={offer.tokenValues}
        />
      }
      description={
        <OfferTokenizedContent
          content={offer.cardContent?.description}
          tokenValues={offer.tokenValues}
        />
      }
      url={offer.fullPath}
    />
  );
};

export default OfferSliderCard;
